import styles from '../UploadConfigModal.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { ButtonWithTooltip } from '../../../buttons/ButtonWithTooltip'

interface UploadConfigDeleteFileProps {
    idx: number
    onDelete: (idx: number) => void
}

export const UploadConfigDeleteFile = (props: UploadConfigDeleteFileProps) => {
    const { idx, onDelete } = props
    const handleDelete = () => onDelete(idx)

    return (
        <ButtonWithTooltip tooltip={'Delete'}>
            <button
                onClick={handleDelete}
                className={`${styles.delete} app-color-default`}
            >
                <FontAwesomeIcon icon={faTrash} />
            </button>
        </ButtonWithTooltip>
    )
}
